export function initPuffBlock(): void {

    const buttons = document.querySelectorAll<HTMLButtonElement>(".toggle-button");

    buttons.forEach(button => {

        button.addEventListener("click", () => {

            const container = button.previousElementSibling as HTMLElement | null;
            if (!container) return;

            const fade = container.querySelector(".fade") as HTMLElement | null;

            const isExpanded = container.classList.contains("expanded");

            if (isExpanded) {
                // collapse
                container.style.maxHeight = container.scrollHeight + "px";
                requestAnimationFrame(() => {
                    container.style.maxHeight = "75px";
                });
                container.classList.remove("expanded");
                fade?.classList.remove("hidden");
                button.textContent = readMoreText;

            } else {
                // expand
                container.style.maxHeight = container.scrollHeight + "px";
                container.classList.add("expanded");
                fade?.classList.add("hidden");
                button.textContent = hideText;
            }

        });
    });
}